<template>
    <div>
        <div class="header pageWarp">
            <div class="left">
                <span>金融服务平台管理后台-v1.0</span>
            </div>
            <div class="right">
                <span>{{username}}</span>
                <!-- <span><i class="el-icon-document"></i></span> -->
                <span>
                    <el-dropdown trigger="click" @command="handleCommand">
                    <i class="el-icon-setting setting"></i>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="1">个人资料</el-dropdown-item>
                        <el-dropdown-item command="2">修改密码</el-dropdown-item>
                        <el-dropdown-item command="3">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                    </el-dropdown>
                </span>
            </div>
        </div>
        <!-- 个人资料弹出层 -->
        <el-dialog
            title="个人资料"
            :visible.sync="dialogInfo"
            width="30%">
            <div class="basic">
                <div class="child">
                    <div class="name">姓名：</div>
                    <div class="content">{{userInfo.realName||'--'}}</div>
                </div>
                <div class="child">
                    <div class="name">账号：</div>
                    <div class="content">{{userInfo.username||'--'}}</div>
                </div>
                <div class="child" v-if="userInfo.sysRoleVoList&&userInfo.sysRoleVoList.length>0">
                    <div class="name">角色：</div>
                    <div class="content">
						<span
							v-for="(i,index) in userInfo.sysRoleVoList"
							:key="index"
							v-if="userInfo.sysRoleVoList.length==1"
						>{{i.roleName||'--'}}</span>
						<span
							v-for="(i,index) in userInfo.sysRoleVoList"
							:key="index"
							v-if="userInfo.sysRoleVoList.length>1"
						>{{i.roleName||'--'}}、</span>
					</div>
                </div>
            </div>
        </el-dialog>
        <!-- 修改密码弹出层 -->
        <el-dialog
            title="修改密码"
            :visible.sync="dialogPassword"
            width="30%"
            :close-on-click-modal="false">
            <div class="forms" v-if="dialogPassword">
                <div class="child">
                    <div class="name"><span>*</span>原密码：</div>
                    <div><el-input v-model="sendInfo.name1"></el-input></div>
                </div>
                <div class="error" v-if="errors['sendInfo.name1']">错误提示：{{errors['sendInfo.name1']}}</div>
                <div class="child">
                    <div class="name"><span>*</span>新密码：</div>
                    <div><el-input v-model="sendInfo.name2"></el-input></div>
                </div>
                <div class="hint">由字母、数字、字符组成，6-20位，区分大小写</div>
                <div class="error" v-if="errors['sendInfo.name2']">错误提示：{{errors['sendInfo.name2']}}</div>
                <div class="child">
                    <div class="name"><span>*</span>重新输入密码：</div>
                    <div><el-input v-model="sendInfo.name3"></el-input></div>
                </div>
                <div class="error" v-if="errors['sendInfo.name3']">错误提示：{{errors['sendInfo.name3']}}</div>
                <div class="doubleBtn">
                    <el-button type="primary" @click="cancel">取消</el-button>
                    <el-button type="primary" @click="submit">保存</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data(){
        return{
			userInfo:JSON.parse(window.localStorage.getItem('userInfo'))||{},
            dialogInfo:false,//个人资料弹出层
            dialogPassword:false,//修改密码弹出层
            sendInfo:{//提交密码的表单信息
                name1:'',//原密码
                name2:'',//新密码
                name3:'',//重新输入密码
            },
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        },
        username(){
            return this.$store.state.user.username
        }
    },
    vuerify: {
        'sendInfo.name1':'password',
        'sendInfo.name2':'password',
        'sendInfo.name3':{
            test:function(){
                if(this.sendInfo.name2!=this.sendInfo.name3){
                    return false;
                }else{
                    return true;
                }
            },
            message:'两次密码不一致'
        },
    },
    mounted(){
    },
    methods:{
        //点击设置选项
        handleCommand:function(command){
            switch(command){
                case '1':
                    this.dialogInfo=true;
                    break;
                case '2':
                    this.isShow()
                    break;
                case '3':
                    this.$store.commit({
                        type:'user/loginOut'
                    })
                    this.$router.push('/login');
                    break;
            }
        },
        isShow(){
            this.dialogPassword=true;
            this.sendInfo = {
                name1:'',//原密码
                name2:'',//新密码
                name3:'',//重新输入密码
            }
            this.$vuerify.clear();
        },
        //取消按钮
        cancel:function(){
            this.$vuerify.clear();
            this.dialogPassword=false
        },
        //保存按钮
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
                let datas = this.sendInfo
                let sendInfo = {
                    originalPassword:datas.name1,
                    newPassword:datas.name2,
                    confirmPassword:datas.name3
                }
                this.$axiosz.put('/backstage/sysUser/password/', this.$qs.stringify(sendInfo)).then((r) => {
                    if (r.code == 200) {
                        this.$message({
                            type: 'success',
                            message: '操作成功!'
                        });
                        this.dialogPassword=false
                    } else {
                        this.$alert(r.msg)
                    }
                })
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 70px;
    // padding: 0 20px;
    background: white;
    .left{
        display: flex;
        align-items: center;
        div{
            background: #152259;
            height: 70px;
            width: 249px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
        }
        span{
            font-size:18px;
            font-family:Microsoft YaHei;
            font-weight:bold;
            line-height:36px;
            color:rgba(51,51,51,1);
            margin-left:30px;
        }
        img{
            width: 180px;
        }
    }
    .right{
		padding-right: 20px;
        span{
            color: #515151;
            &:not(:first-child){
                cursor: pointer;
            }
            &:not(:last-child){
                margin-right: 20px;
            }
            .setting{
                color: #515151;
            }
        }
    }
    
}
</style>